import { render, staticRenderFns } from "./Solo.vue?vue&type=template&id=a94a64a0&"
import script from "./Solo.vue?vue&type=script&lang=js&"
export * from "./Solo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports